import React, { useCallback, useContext, useEffect, useState } from 'react'
import Button from '../../../../../components/button/Button'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import { PrelevementModalModel } from '../../../../../types/prelevement/prelevementModalModel'
import { savePrelevement } from '../../../../reducers/prelevement/actions'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getLatestDateRelancePrelevement, setDateRelance } from '../../../../contracts/contractMapper'
import { ContractsModel } from '../../../../../types/contracts/contractsModel'
import { RootState } from '../../../../reducers'
import { SignResponseModel } from '../../../profileModel'
import fetchFactory from '../../../../../utils/fetchFactory'
import { configEnum } from '../../../../../enums/fetchFactoryEnum'
import { SIGN_STATUS } from '../../../../../enums/profileEnum'
import links from '../../../../../enums/linksEnum'
import { useHistory } from 'react-router'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import { fromEnum } from './enums/fromEnum'
import CloseIcon from '@material-ui/icons/Close'
import Loader from '../../../../../components/loader/Loader'
import SvgInformation from '../../../../../icons/Information'
import portals from '../../../../../enums/portalsEnum'
import { Grid } from '@material-ui/core'
import { displayModal } from '../../../../reducers/modal/actions'
import { modalTypes } from '../../../../../enums/modalTypeEnum'
import { EDLContext } from '../../../../dashboard/edl/context/EDLContext'
import EDLModal from '../../../../dashboard/edl/components/EDLModal'
import { UserModel } from '../../../../../types/user/userModel'
import { saveRequests } from '../../../../reducers/requests/actions'
import { convertRequestList } from '../../../../requests/requestMapper'
import errorCatcher from '../../../../../utils/errorCatcher'
import { MakeRequestContext } from '../../../../requests/makeRequest/MakeRequestContext'
import { propertyType } from '../../../../../enums/contractsEnum'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            containerStyle: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',

                '& > div': {
                    textAlign: 'left'
                }
            },
            containerSmallScreenStyle: {
                width: '100%',
                padding: 15,
                margin: 'auto',

                '& div:nth-child(2)': {
                    margin: 'auto',

                    '& img': {
                        width: '100%'
                    }
                }
            },
            buttonsContainerStyle: {
				gap: '16px',
                '& div:first-child': {
                    marginBottom: 15
                }
            },
            iframe: {
                width: '100%',
                height: '70vh',
                '& iframe': {
                    width: '100%',
                    height: '100%'
                }
            },
            descriptionStyle: {
                width: '100%',
                '& > span:first-child, & img': {
                    marginRight: 15
                }
            },
            close: {
                justifySelf: 'end',
                cursor: 'pointer'
            },
            descriptionContainer: {
                marginBottom: 20,
                display: 'flex',
                flexDirection: 'row'
            },
	        signatureInfo: {
		        position: 'relative',
		        marginBottom: 30,
		        minHeight: 50,
		        alignContent: 'center',
		        ...styles(theme).text15,
		        '& svg': {
			        position: 'absolute',
			        left: -6,
			        top: 0,
		        },
	        },
	        signatureInfoMessage: {
		        marginLeft: 50
	        }
        }
    )
)

interface AcceptingProps {
    signResponse?: SignResponseModel,
    stepNumber: number,
    closeDialog: () => void,
    resetStep: () => void,
    signStatus?: string,
    setSignStatus: (value: string) => void,
    from?: fromEnum
}

interface Store {
    savePrelevement: (prelevementData: PrelevementModalModel) => void,
    contracts: ContractsModel[]
}

type PrelevementSummaryProps = AcceptingProps & Store

const PrelevementSummary: React.FC<PrelevementSummaryProps> = (
    {
        signResponse,
        stepNumber,
        closeDialog,
        resetStep,
        savePrelevement,
        contracts,
        setSignStatus,
        signStatus,
        from = fromEnum.prelevement
    }
) => {
    const classes = useStyle()
	const { refresh, offre, idVisiteEdls, idRequete, dateCongesSouhaitee } = useContext(EDLContext)
	const { request } = useContext(MakeRequestContext)
	const history = useHistory()
    const [loadingStep5, setLoadingStep5] = useState<boolean>(false)
	const dispatch = useDispatch()
	const theme = useTheme()
	const user = useSelector((state: RootState) => state.user)

	const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const containerClass: ClassValue = classNames(
        'row',
        classes.containerStyle,
        {
            [classes.flexColumnReverse]: !isLargeScreen,
            [classes.containerSmallScreenStyle]: !isLargeScreen
        }
    )

    const titleClass: ClassValue = classNames(
        classes.colorBlue,
        isLargeScreen ? classes.title1 : classes.title6
    )

    const textClass: ClassValue = classNames(
        classes.colorBlue,
        isLargeScreen ? classes.text13_opacity : classes.text2_opacity
    )

    const textRdvClass: ClassValue = classNames(
        classes.colorBlue,
        isLargeScreen ? classes.text13 : classes.text2
    )

    const buttonsContainerClass: ClassValue = classNames(
        'column',
        {
            [classes.buttonsContainerStyle]: !isLargeScreen
        }
    )

    const descriptionClass: ClassValue = classNames(
        classes.flex,
        classes.descriptionStyle,
        {
            [classes.alignCenter]: isLargeScreen,
            [classes.flex]: !isLargeScreen,
            [classes.flexColumn]: !isLargeScreen
        },
        classes.colorBlue
    )

    const selectedContracts = Array.isArray(request.contract)
        ? request.contract
        : request.contract ? [request.contract] : []
    const hasApartmentInDeposit = selectedContracts.some(c => c?.type === propertyType.apartment)

    //Go to request tab
    const goToRequests = () => {
        history.push(links.requests)
    }

    const finish = () => {
        resetStep()
        closeDialog()
        goToRequests()
        savePrelevement({
            subscribePrelevementModal: false
        })
        setDateRelance(getLatestDateRelancePrelevement(contracts).interlocutor)
    }

    const finishRefuse = useCallback(() => {
        resetStep()
        closeDialog()
    }, [resetStep, closeDialog])

	const REQUESTS_ERROR = 'get_requests'

	const updateRequests = (user: UserModel) => {
		fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/demande/getRequestList${user.dateDeModification ? '?date=' + user.dateDeModification : ''}`)
			.then((response: any) => {
				if (response && response.value) {
					dispatch(
						saveRequests(convertRequestList(response.value))
					)
				}
			})
			.catch((error) => {
				dispatch(errorCatcher(error, REQUESTS_ERROR))
			})
	}

	const getResponse = useCallback(() => {
        fetchFactory(
            `/api/ec_${process.env.REACT_APP_TARGET}/signature/checkStatus`,
            {
                body: JSON.stringify({
                    signatureId: signResponse?.id,
                    from
                }),
                method: configEnum.post
            }
        )
            .then((signStatus: any) => {
                if (signStatus && signStatus.status !== SIGN_STATUS.EN_COURS && signStatus !== SIGN_STATUS.FINALISATION) {
                    if (signStatus.status === SIGN_STATUS.ECHEC) {
                        finishRefuse()
                    } else {
	                    updateRequests(user)
	                    saveInteractions(
                            {
                                category: 'Mes Services',
                                action: 'Souscrire en ligne',
                                label: 'Mes Services::Souscrire en ligne::Demande envoyée'
                            }
                        )

                        setSignStatus(signStatus.status)
                    }
                }
            })
            .catch((e: any) => console.log(e))
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [signResponse, finishRefuse, setSignStatus, from])

    React.useEffect(() => {
        const interval = setInterval(() => {
            getResponse()
        }, 3000)
        return () => clearInterval(interval)
    }, [getResponse])

	useEffect(() => {
        if (signResponse) {
	        setLoadingStep5(true)
            setTimeout(() => {
	            setLoadingStep5(false)
                // @ts-ignore
                new Yousign({
                    signatureLink: signResponse.link,
                    iframeContainerId: 'iframe-container',
                    isSandbox: false
                })
            }, 3000)
        }
	}, [signResponse])

	//Loader de la page
	if (loadingStep5) {
		return (
			<Loader />
		)
	}

	if (signResponse && !signStatus) {
        return (<>
            <div className={classes.descriptionContainer}>
                <div className={descriptionClass}>
						<span>
							<span className={classes.text11}>
								{stepNumber}
							</span>

							<span className={classes.text11_opacity}>
								/{stepNumber}
							</span>
						</span>

                    {
                        isLargeScreen &&
                        <img src="img/requests/longArrow.svg" alt="Long arrow"/>
                    }

                    <span className={classes.text11}>
					{
                        from === fromEnum.leaveDeposit ? (
                            <FormattedMessage
                                id="requests.makeRequest.step5.iframeTitle"
                                defaultMessage="Signature de la résiliation du bail"
                                description="Summary text"
                            />
                        ) : (
                            <FormattedMessage
                                id="profile.prelevement.step3.iframeTitle"
                                defaultMessage="Step description"
                                description="Step description"
                            />
                        )
                    }
				</span>

                </div>
                {from === fromEnum.leaveDeposit && (
                    <span className={classes.close}>
					<CloseIcon onClick={() => {
                        resetStep()
                        closeDialog()
                        goToRequests()
                    }}/>
				</span>
                )}
            </div>
            {from === fromEnum.leaveDeposit && (
	            <Grid container item xs={12}>
		            <div className={classes.signatureInfo}>
				        <div>
					        <SvgInformation color={theme.palette.green.main} />
				        </div>
				        <div className={classes.signatureInfoMessage}>
					        <FormattedMessage
						        id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.five`}
						        defaultMessage="Après la signature de votre demande de résiliation, veuillez attendre quelques minutes avant de voir votre demande s’afficher sur votre espace personnel."
						        description="Make request step 4, leave deposit informations fifth bullet"
					        />
				        </div>
		            </div>
	            </Grid>
            )}
            <div id="iframe-container" className={classes.iframe}></div>
        </>)
    }

    return (
        <div className={containerClass}>
            <div className="col-xs-12 col-md-8 center-sm">
                <h1 className={titleClass}>
                    <FormattedMessage
                        id="profile.prelevement.step3.title"
                        defaultMessage="Votre demande a bien été prise en compte."
                        description="Summary title"
                    />
                </h1>

                <p className={textClass}>
                    {
                        from === fromEnum.leaveDeposit ? (
                            <FormattedMessage
                                id="requests.makeRequest.step5.text"
                                defaultMessage="Nous vous répondons dans les meilleurs délais"
                                description="Summary text"
                            />
                        ) : (
                            <FormattedMessage
                                id="profile.prelevement.step3.subTitle"
                                defaultMessage="Nous revenons vers vous au plus vite concernant votre souscription au prélèvement automatique"
                                description="Summary subtitle"
                            />
                        )
                    }
                </p>


                <p className={textRdvClass}>
                    {
                        from === fromEnum.leaveDeposit && hasApartmentInDeposit && (
                            <FormattedMessage
                                id="requests.makeRequest.step5.textRdv"
                                defaultMessage="Pensez à prendre rendez-vous dès maintenant pour votre Etat des lieux de sortie et remise des clés auprès de votre YouFirst Manager."
                                description="Summary text"
                            />
                        )
                    }
                </p>

                <div className={buttonsContainerClass}>
                    <div className="row">
	                    {from === fromEnum.leaveDeposit && hasApartmentInDeposit &&
		                    <div className="col-xs-6">
			                    <Button
				                    background="backgroundAccessibility"
				                    color="colorWhite"
				                    textStyle="text8"
				                    size="bigButton"
				                    onClick={() => dispatch(displayModal(modalTypes.edls))}
			                    >
				                    <FormattedMessage
					                    id="requests.makeRequest.step5.rdv"
					                    defaultMessage="Prendre rendez-vous"
					                    description="Summary button"
				                    />
			                    </Button>
		                    </div>
	                    }
	                    <div className="col-xs-6">
	                        <Button
	                            background="backgroundAccessibility"
	                            color="colorWhite"
	                            textStyle="text8"
	                            size="bigButton"
	                            onClick={finish}
	                        >
	                            <FormattedMessage
	                                id="requests.makeRequest.step5.finish"
	                                defaultMessage="Terminer"
	                                description="Summary button"
	                            />
	                        </Button>
	                    </div>
                    </div>
                </div>
            </div>

            <div className="col-xs-12 col-sm-4 center-sm">
                <img
                    src="img/contracts/requestSummary/sendImg.png"
                    alt="Send icon"
                />
            </div>
		        <>
			        {!!offre && idRequete &&
				        <EDLModal
					        offre={offre}
					        onValidate={() => refresh()}
					        idRequete={idRequete}
					        idVisiteEdl={idVisiteEdls}
					        isEdls
					        dateEffetBail={null}
					        dateCongesSouhaitee={dateCongesSouhaitee}
				        />
			        }
		        </>
        </div>
    )
}

const mapStateToProps = (state: RootState) => (
    {
        contracts: state.contracts
    }
)

const mapDispatchToProps = {
    savePrelevement
}

export default connect(mapStateToProps, mapDispatchToProps)(PrelevementSummary)
